import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'utils/utils';
import { Row, Col, Modal, Icon, Button } from 'antd';
import EmailUpdateCode409 from 'components/login/code/EmailUpdateCode409';
import EmailUpdateCode424 from 'components/login/code/EmailUpdateCode424';

class Loading extends Component {
    constructor(props) { super(props); }
    render() {
        const { code } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='loading' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '20px' }}>
                        {'Loading...'}
                    </span>
                </div>
            );
        }
    }
}

class Pending extends Component {
    constructor(props) { super(props); }
    render() {
        const { code, type } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='loading' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '17px' }}>
                        {'Attempting to update email...'}
                    </span>
                </div>
            );
        }
    }
}

class Success extends Component {
    constructor(props) { super(props); }
    render() {
        const { code, service, doClose, clearFields } = this.props;
        switch(code) {
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <Icon type='check-circle-o' style={{ fontSize: '20px', marginRight: '8px' }} />
                    <span style={{ fontSize: '20px' }}>
                        {'Email successfully updated'}
                    </span>
                    <div style={{ margin: '20px 0px 0px 0px' }}>
                        <Link to={ROUTES.ROOT}>
                            <Button
                                size='small'
                                style={{ width: '200px', borderRadius: '20px' }}
                                onClick={() => {
                                    clearFields();
                                    doClose();
                                    service();
                                }}
                            >
                                {'Ok'}
                            </Button>
                        </Link>
                    </div>
                </div>
            );
        }
    }
}

class Failure extends Component {
    constructor(props) { super(props); }
    render() {

        const { code, service, doClose } = this.props;
        
        switch(code) {
            case 409: return <EmailUpdateCode409 doClose={doClose} service={service} />;
            case 424: return <EmailUpdateCode424 doClose={doClose} service={service} />;
            default: return (
                <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                    <span style={{ fontSize: '20px' }}>
                        {'Unable to update email'}
                    </span>
                    <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '3px' }}>
                        {'For assistance please contact the FTSP Help Desk.'}
                    </div>
                    <div style={{ margin: '20px 0px 0px 0px' }}>
                        <Button
                            size='small'
                            onClick={() => {
                                doClose();
                                service();
                            }}
                            style={{ width: '200px', borderRadius: '20px' }}
                        >
                            {'Ok'}
                        </Button>
                    </div>
                </div>
            );
        }
    }
}

export default class PasswordResetModal extends Component {
    constructor(props) { super(props); }
    render() {
        const
        { services, request, show, doClose, clearFields } = this.props,
        props = {
            doClose,
            clearFields,
            status: request.status,
            code: request.code,
            service: () => services.togglePasswordResetModal()
        };

        return (
            <div style={{
                display: show ? 'block' : 'none',
                width: '450px',
                padding: '20px',
                position: 'absolute',
                backgroundColor: 'rgb(238, 238, 238)',
                boxShadow: 'rgb(194, 194, 194) 0px 0px 20px 10px',
                borderRadius:
                    props.status === 'success' ? '16px' :
                    props.status === 'failure' ? '18px' : '40px',
                transform: 'translate(-50%, -50%)',
                top: '57%',
                left: '50%',
                overflow: 'auto'
            }}>{
                props.status === 'pending' ? <Pending {...props} /> :
                props.status === 'success' ? <Success {...props} /> :
                props.status === 'failure' ? (
                    <Failure {...props} />
                ) : <Loading />
            }</div>
        );
    }
}
